import type { AttributionProperties } from '../types/analytics'

const sessionKey = 'povli_attribution'

function value(params: URLSearchParams, ...keys: string[]): string | null {
  for (const key of keys) {
    const found = params.get(key)?.trim()
    if (found) return found.slice(0, 500)
  }
  return null
}

export function readAttribution(search: string): AttributionProperties {
  const params = new URLSearchParams(search)
  const campaignId = value(params, 'campaign_id')
  const adsetId = value(params, 'adset_id')
  const adId = value(params, 'ad_id')
  return {
    campaign: value(params, 'campaign') ?? campaignId,
    adset: value(params, 'adset') ?? adsetId,
    creative: value(params, 'creative', 'creative_id') ?? adId,
    campaign_id: campaignId,
    adset_id: adsetId,
    ad_id: adId,
    utm_source: value(params, 'utm_source'),
    utm_medium: value(params, 'utm_medium'),
    utm_campaign: value(params, 'utm_campaign'),
    utm_content: value(params, 'utm_content'),
    utm_term: value(params, 'utm_term'),
    fbclid: value(params, 'fbclid'),
  }
}

export function getAttribution(search = window.location.search): AttributionProperties {
  const current = readAttribution(search)
  const hasCurrent = Object.values(current).some(Boolean)

  try {
    const stored = sessionStorage.getItem(sessionKey)
    const previous = stored ? (JSON.parse(stored) as Partial<AttributionProperties>) : {}
    const merged = Object.fromEntries(
      Object.entries(current).map(([key, currentValue]) => [key, currentValue ?? previous[key as keyof AttributionProperties] ?? null]),
    ) as unknown as AttributionProperties
    if (hasCurrent || stored) sessionStorage.setItem(sessionKey, JSON.stringify(merged))
    return merged
  } catch {
    return current
  }
}
